import React from 'react';

const Spinner = (props) => {
  return (
    <>
      <div className='loadingio-spinner'>
        <div className='ldio-s985a3d0pi9'>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <style type='text/css'>
        {`


        @keyframes ldio-s985a3d0pi9 {
        0 % {opacity: 1}
        100% {opacity: 0}
      }
        .ldio-s985a3d0pi9 div {
        left: 48.5px;
        top: 24px;
        position: absolute;
        animation: ldio-s985a3d0pi9 linear 1s infinite;
        background: #635eb5;
        width: 3px;
        height: 12px;
        border-radius: 1.5px / 1.56px;
        transform-origin: 1.5px 26px;
      }.ldio-s985a3d0pi9 div:nth-child(1) {
        transform: rotate(0deg);
        animation-delay: -0.9166666666666666s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(2) {
        transform: rotate(30deg);
        animation-delay: -0.8333333333333334s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(3) {
        transform: rotate(60deg);
        animation-delay: -0.75s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(4) {
        transform: rotate(90deg);
        animation-delay: -0.6666666666666666s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(5) {
        transform: rotate(120deg);
        animation-delay: -0.5833333333333334s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(6) {
        transform: rotate(150deg);
        animation-delay: -0.5s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(7) {
        transform: rotate(180deg);
        animation-delay: -0.4166666666666667s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(8) {
        transform: rotate(210deg);
        animation-delay: -0.3333333333333333s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(9) {
        transform: rotate(240deg);
        animation-delay: -0.25s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(10) {
        transform: rotate(270deg);
        animation-delay: -0.16666666666666666s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(11) {
        transform: rotate(300deg);
        animation-delay: -0.08333333333333333s;
        background: #635eb5;
      }.ldio-s985a3d0pi9 div:nth-child(12) {
        transform: rotate(330deg);
        animation-delay: 0s;
        background: #635eb5;
      }
        .loadingio-spinner {
        width: 50px;
        height: 50px;
        display: inline-block;
        overflow: hidden;
        background: none;
      }
        .ldio-s985a3d0pi9 {
        width: 100%;
        height: 100%;
        position: relative;
        transform: translateZ(0) scale(0.5);
        backface-visibility: hidden;
        transform-origin: 0 0; /* see note above */
      }
        .ldio-s985a3d0pi9 div {box - sizing: content-box;}
        /* generated by https://loading.io/ */
        `}
      </style>
    </>
  );
};

export default Spinner;
